import styled from 'styled-components'

export const Wrapper = styled.div`
    position: absolute;
    top: 10%;
    left: 0;
    right: 0;
    margin: auto;
    display: none;
    justify-content: center;
    align-items: center;
    z-index: 8;
`

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    width: 60vw;
    max-width: 200px;
    height: 38px;
    background: #555555;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    padding: 0 3%;
`

export const Info = styled.div`
    text-align: center;
    font-size: 12px;
    color: white;
`
